import { MasterTransaction } from '@model/MasterTransaction'

import { isTransactionRedirectStaticType } from './MasterTransactionDto'

export enum PaymentProviderType {
  Bank = 1,
  CardProvider = 2,
  PSP = 3,
  PaymentAgent = 4,
  Crypto = 5,
  None = 0,
}

export const isPaymentProviderBankType = (
  walletDepositCategoryType: number | undefined,
  responseData?: MasterTransaction | undefined
): boolean => {
  return (
    PaymentProviderType.Bank === walletDepositCategoryType ||
    (PaymentProviderType.PSP === walletDepositCategoryType &&
      isTransactionRedirectStaticType(responseData))
  )
}

export const showPSPFields = (walletDepositCategoryType: number | undefined): boolean =>
  isPaymentProviderPSPType(walletDepositCategoryType) ||
  isPaymentProviderCardProviderType(walletDepositCategoryType) ||
  isPaymentProviderBankType(walletDepositCategoryType) ||
  isPaymentProviderCryptoType(walletDepositCategoryType)

export const isPaymentProviderCardProviderType = (
  walletDepositCategoryType: number | undefined
): boolean => {
  return PaymentProviderType.CardProvider === walletDepositCategoryType
}

export const isPaymentProviderPSPType = (
  walletDepositCategoryType: number | undefined
): boolean => {
  return PaymentProviderType.PSP === walletDepositCategoryType
}

export const isPaymentProviderPaymentAgentType = (
  walletDepositCategoryType: number | undefined
): boolean => {
  return PaymentProviderType.PaymentAgent === walletDepositCategoryType
}

export const isPaymentProviderNoneType = (
  walletDepositCategoryType: number | undefined
): boolean => {
  return PaymentProviderType.None === walletDepositCategoryType
}

export const isPaymentProviderCryptoType = (
  walletDepositCategoryType: number | undefined
): boolean => {
  return PaymentProviderType.Crypto === walletDepositCategoryType
}

export const isPaymentProviderCrypto = (
  providerCategoryId: number | undefined,
  providerName?: string | null
): boolean => {
  if (isPaymentProviderCryptoType(providerCategoryId)) {
    return true
  }

  if (providerName && providerName.includes('BinancePay')) {
    return true
  }

  return false
}

// Required by WCA-2693 - New Proceed modal should only open for "Credit or Debit Card" method
// Required by WCA-605 - New Proceed modal should only open for specific methods
export const creditDebitCardPaymentProviderMethodId = '2d5792d8-4986-11ea-9e5d-000c29df7a17'
export const unionPayPaymentProviderMethodId = '87f5fa17-b401-11eb-a2ad-06e70b382a0c'

// Local Internet Banking detection
const LOCAL_IB_POSITIVE_REGEX =
  /(?:\binternet\s*banking\b|\blocal\b[\s\-–]*.*\binternet\s*banking\b|\binternet\s*banking\b.*[\s\-–]*\blocal\b|\binternet\s*banking\b.*\bchannel\b|\bchannel\b.*\binternet\s*banking\b)/i
const LOCAL_IB_NEGATIVE_REGEX = /\binstant\b|\bonline\b/i

export const isLocalInternetBankingText = (text?: string | null): boolean => {
  if (!text) {
    return false
  }
  return LOCAL_IB_POSITIVE_REGEX.test(text) && !LOCAL_IB_NEGATIVE_REGEX.test(text)
}

export const isLocalInternetBankingProvider = (provider?: {
  name?: string
  description?: string
  listingDescription?: string | undefined
  providerCategory?: { id?: number }
}): boolean => {
  if (!provider) {
    return false
  }
  if (!isPaymentProviderPSPType(provider.providerCategory?.id)) {
    return false
  }
  return (
    isLocalInternetBankingText(provider.name) ||
    isLocalInternetBankingText(provider.description) ||
    isLocalInternetBankingText(provider.listingDescription)
  )
}
